
export class TimesheetEntryRepository {
    /**
     * @abstract
     * @param {Date} start
     * @param {Date} end
     * @return {Promise<TimesheetEntry[]>}
     */
    async getDuring(start, end) {

    }

    /**
     * @abstract
     * @return {Promise<TimesheetEntry[]>}
     */
    async getRunningEntries() {

    }
}